module.exports = __webpack_public_path__ + "media/images/return_cases/customer-b6c030b38a80ea2f3d5188c62b6c7304.svg";